import React, {useEffect, useState, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {Link} from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import required modules


function Art(props) {
    const [on,setOn] = useState(false);
    const location = useLocation();
    const locationNum = location.pathname.split("/");
    const thisTarget1 = useRef([]);
    console.log(thisTarget1);
    const tTargetClick = (n) => {
       thisTarget1.current[n].scrollIntoView({ behavior: 'smooth' });
       //const thisTop = thisTarget1.current[n].offsetTop;
       
    }
    const thisData = [
        {year :"2017", title: "길있는길 7인 그룹전",topScroll:0}
    ]
    console.log(props);
    useEffect(() => {
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        const timeOut = setTimeout(()=> setOn(true), 100);
        return () => clearTimeout(timeOut);
    });
    return (
        <div className={on ? "conBox on" : "conBox"}>
            <div className="topBg"></div>
            <div className="conTopWave">
                <div className="conTopWaveIn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6000" height="240" viewBox="0 0 6000 240" preserveAspectRatio="xMidYMid slice">
                        <pattern id="wave" width=".25" height="1.1" patternContentUnits="objectBoundingBox">
                        <path fill="#1A2C2D" d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"></path>
                        </pattern>
                        <rect width="6000px" height="140"></rect>
                    </svg>
                </div>
                <div className="photoLeftBox">
                    <ul>
                        {


                        }
                        <li className={locationNum[2] == '2017' ? "on" : ""}><Link to="/art/2017" onClick={() => tTargetClick(0)}>2017<span>길있는길 7인 그룹전</span></Link></li>
                        <li className={locationNum[2] == '2011' ? "on" : ""}><Link to="/art/2011" onClick={() => tTargetClick(1)}>2011<span>Simulacre World</span></Link></li>
                        <li className={locationNum[2] == '2009' ? "on" : ""}><Link to="/art/2009" onClick={() => tTargetClick(2)}>2009<span>Dreaming in Simulacre</span></Link></li>
                        <li className={locationNum[2] == '2008' ? "on" : ""}><Link to="/art/2008" onClick={() => tTargetClick(3)}>2008<span>Korea-New York Exhibition</span></Link></li>
                    </ul>
                </div>
            </div>
            <div className="pageNameBox">
                <div className="pageNameBoxIn">
                    <h2>PORTFOLIO</h2>
                    <p>Art</p>
                </div>
            </div>
            <div className="photoConBoxIn">
                <div className="photoRightBox">
                    <ul>
                        <li>
                            <div ref={el => (thisTarget1.current[0] = el)} className="thisTopPoint"></div>
                            <h3><span>2017</span> 길있는길 7인 그룹전</h3>
                            <p>
                                <span>길</span>있는길은 예술가 7인의 길에 대한 주제로 진행된 그룹전이다. 당시 Simulacre를 기반으로 여러 작품을 출품했다.
                            메인작품인 '2017 Dreaming in Simulacre'은 진리에 대한 근원적 질문을 던지는 작품이다. <br/><br/>우리는 가상속에서 살고있다. 이것은 단순히 on-line 속의 세상을 이야기 하는것이 아니다. 
                            항상 웃고있는 아이돌 가수나 행복해야만 하는 놀이동산 종사자들의 모습은 '진실'이라는 단어보다 잘 짜여진 '각본'이라는 단어가 어울린다. 우리는 무엇인 진실이고, 무엇이 나인지 잘 알지 못한다. 때로는 진짜보다는 가짜인 상태를 오히려 원할수도 있으며 심지여는 그것을 구분해 낼 수도 없다.<br/><br/>
                            작품속 건물들은 휘어져 있다. 이것은 가상이다. 우리가 알고있는 사실은 건물은 이런식으로 휘어지지 않는다. 이러한 Simulacre속의 세상에 중력을 거스르는 고양이가 거꾸로 서있다. 심지여는 풍선처럼 부풀어  있는 상태로 말이다. 이것역시 가상인것일까? 감상자는 큰 고민없이 가상이라 이야기 할것이다. <br/><br/>
                            과역 '가장, 가상, 거짓' 이라고 단정짓는 그 기준은 무엇일까? 너무도 쉽게 판단되어지는 그 잣대에 대한 물음이다. 만약 진실과 거짓을 구분짓고자 한다면 명확한 판단기준이 근거가 되어야 한다. 
                            하지만 과연 우리는 그것을 판단기준을 제시할 수 있을까?<br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2017_01.png"} alt="" />
                                    <figcaption><strong>Dreaming in Simulacre</strong> 종이에 담채, 730 X 1030mm, 2017 </figcaption>
                                </figure>

                            </p>
                            <p>
                                <span>청</span>경자화백은 '꽃'과 '여성'을 주요 소재로 채택하며 채색위주의 화려한 화법을 이어나갔다. 당시는 파격적인 것이였고 현재에 와서는 가장 유명한 여성화가 중 하나로 평가되어진다.
                            그녀는 위작 놀란으로도 유명하다. '미인도'라는 작품을 화백 스스로 자신이 그린 그림이 아니라고 주장을 했기 때문이다. 프랑스 뤼미에르 감정연구소의 감정에서는 위작, 안목감정 결과는 진품으로 발표된다.<br/><br/>
                            2015년 그녀가 세상을 떠날때까지도 미인도를 진품으로 인정하지 않았다. 당사자가 없어진 상황에 이 작품을 진품과 가품을 결정할 수 있을까? 물론 그린 당사자가 살아있었더라도 인정되지 않았기 때문에 이는 애초에 결론을 낼 수 없는 사안이였는지 모르겠다.
                            <br/>진짜같은 가짜든 가짜같은 진짜이든 우리는 그것을 알 수 없다. 절대적인 평가기준이 필요한데 그것은 인간의 영역을 넘어서는 것이다. 오히려 담벼락 넘어에서, 자동차 아래에서, 지붕위에서 우리를 유심히 관찰하는 고양이의 눈으로 보는것이 정확할 것이다. 고양이의 지성이 좀더 끌어올려진다면
                            그들이 좀더 합리적인 결론을 내려줄 수 있을 것이다.<br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2017_02.png"} alt="" />
                                    <figcaption><strong>미인도</strong> 종이에 채색, 270 X 220mm, 2017 </figcaption>
                                </figure>

                            </p>
                        </li>
                        <li>
                            <div ref={el => (thisTarget1.current[1] = el)} className="thisTopPoint"></div>
                            <h3><span>2011</span> Simulacre World</h3>
                            <p>
                                <span>S</span>imulacre는 삶을 드라마틱하게 만든다. 본질은 특별함이 없지만 그럴싸한 모습으로 변형되어 좀더 근사한 드라마가 만들어진다.
                                본질보다 화려하기 때문에 우리는 Simulacre의 삶을 동경한다. 그때부터 우리는 진실이 중요해지지 않는다. 허구이건 진실이건 지금보다 더 좋아보이면 그만이다.
                                이러한 삶에 우리는 노출되어 있으며 정도의 차이가 있겠지만 우리는 일부이건 전부이건 Simulacre에 매몰되어 있다. 
                                <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2011_01.png"} alt="" />
                                    <figcaption><strong>Simulacre in Simulacre</strong><br/>장지에 채색 & objects & media , 180 X 145 X 60mm, 2011</figcaption>
                                </figure><br/>
                                가난은 부를 동경한다. 부는 가난을 이용한다. 상류의 힘은 하류에서만 나온다. 상류가 하는 행위는 '소비'뿐이고 하류가 하는일은 '노동'뿐이다. 이러한 불균형은 착취에 의해 진행됨으로 지속가능하지 않아 보이지만 사회는 이러한 프로세스로 유지되고 있다. <br/><br/>
                                몸이 아파도 일을 해야 하는 사회, 돈을 벌지 못해 자살하는 사회, 소비의 정도가 삶의 등급으로 평가되는 사회는 우리가 상류를 동경하기 때문에 유지된다. 동경은 암묵적으로 그들의 삶을 묵인해준다. <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2011_02.jpg"} alt="" />
                                    <figcaption><strong>Simulacre in Capitalism</strong><br/>장지에 채색, 460 X 240mm, 2011</figcaption>
                                </figure><br/>
                                생명의 탄생은 DNA로 부터 시작되어진다. <br/>이러한 복제는 삶을 연장시킨다. <br/>그 뿐이다.<br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2011_03.jpg"} alt="" />
                                    <figcaption><strong>Simulacre in clone</strong><br/>장지에 채색, 120 X 220mm, 2011</figcaption>
                                </figure><br/>
                            </p>
                        </li>
                        <li>
                            <div ref={el => (thisTarget1.current[2] = el)} className="thisTopPoint"></div>
                            <h3><span>2009</span> Dreaming in Simulacre</h3>
                            <p>
                                <span>D</span>reaming in Simulacre는 대학교때 부터 이어나간 작품의 화두이다. 꿈속에서의 Simulacre는 허구 속 허구를 뜻한다. 꿈은 진실에서 기인한다. 그러나 진실은 아니다. 우리는 그럴싸한 허구속에 둘러 쌓여있다. 허구 속에서 다시 허구를 만난다고 해서
                                진실이 되진 않는다. 명확한건 허구속에서 만난 허구를 보게되는 순간 우리는 진실로 가는 열쇠를 잃어버린다. 왜냐하면 기준점을 찾을 수 없기 때문이다. 기준점 자체가 허구인지 우리는 판단할 수 없기 때문이다. <br/><br/>
                                우리는 바로 이런 허구속의 허구를 살아간다. <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2009_02.png"} alt="" />
                                    <figcaption><strong>Simulacre in Simulacre</strong> 장지에 채색, 350 X 250mm, 2009</figcaption>
                                </figure>
                                <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2009_03.jpg"} alt="" />
                                    <figcaption><strong>남과여</strong> 장지에 담채, 475 X 325mm, 2009</figcaption>
                                </figure>
                                <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2009_01.png"} alt="" />
                                    <figcaption><strong>꿈을꾸다</strong> 장지에 담채, 300 X 250mm, 2009</figcaption>
                                </figure>
                            </p>
                        </li>
                        <li>
                         <div ref={el => (thisTarget1.current[3] = el)} className="thisTopPoint"></div>
                            <h3><span>2008</span> Korea-New York Exhibition</h3>
                            <p>
                                <span>S</span>imulacre 속에서의 고양이는 절대자의 지휘를 얻는다. 정면을 응시하고 있는 고양이는 진실을 판단할 수 있는 능력을 가졌기 때문이다. 능력이라는 표현보다는 적어도 판단할 수 있는 자격이 있다는 표현이 정확하다.
                                인간은 전통, 문화, 지휘, 인간관계등 다양한 네트워크 속에서 살아간다. 자신의 본능에 의해 살아가는 것이 아니라 여러 요소에 복합적으로 대응하며 적절한 대응방안을 마련하며 살아간다. 판사등과 같이 무엇인가를 결정해야 하는 위치에 있거나
                                감별사 내지 전문가라는 직업도 마찮가지다. 그들은 무엇인가의 기준에 따라 분석하고 판단을 내린다. 그 판단은 옳은 것일까? 혹은 정확한것일까? 이미 인간위 행위를 판단할때 인간이 개입해서는 안된다. 이미 인간의 삶의 이해관계자가 되어 버렸기 때문에
                                인간의 행위에 인간이 잣대를 들이되는것은 순수하지 않다. 그래서 작품에 고양이가 등장한다. 고양이는 우리의 삶을 늘 지켜보고 있으며 누구보다도 우리를 잘 안다. 개와는 조금 다르다. 개는 이미 인간의 삶속에 들어와 있고 그 역시 이해관계자가 되어 버렸다. 
                                약간의 본능을 유지하고 있는 고양이야 말로 인간의 삶을 정확하게 평가해줄만한 대안이라는 뜻이다. <br/><br/>
                                조금 억지스럽고 우수울지 모르겠지만 이것이 얼마나 진실을 알아내기 힘든지에 대한 반증이다.<br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/art/2008_01.jpg"} alt="" />
                                    <figcaption><strong>시뮬라르크 속에서 꿈을꾸다</strong> 장지에 채색, 430 X 530mm, 2008</figcaption>
                                </figure>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
  
export default Art;